module.exports = __webpack_public_path__ + "img/couples-048.2d5e2ab8.jpg";